module.exports = __webpack_public_path__ + "static/1-2ef614597fd50f3ed02c3c5fc7d4ba52.jpg";